"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var config_exports = {};
__export(config_exports, {
  getDefaultRenderMode: () => getDefaultRenderMode
});
module.exports = __toCommonJS(config_exports);
var import_constants = require("./constants");
var getDefaultRenderMode = function() {
  var _ref;
  var _serverConfig_web;
  var CLIENT_RENDER_MODE = process.env.ONE_DEFAULT_RENDER_MODE;
  var serverConfig = globalThis["__vxrnPluginConfig__"];
  if (!CLIENT_RENDER_MODE && import_constants.isWebServer && !serverConfig) {
    if (process.env.IS_VXRN_CLI) {
      throw new Error(`Internal one error: should call setServerConfig before createManifest`);
    }
  }
  return (_ref = CLIENT_RENDER_MODE !== null && CLIENT_RENDER_MODE !== void 0 ? CLIENT_RENDER_MODE : serverConfig === null || serverConfig === void 0 ? void 0 : (_serverConfig_web = serverConfig.web) === null || _serverConfig_web === void 0 ? void 0 : _serverConfig_web.defaultRenderMode) !== null && _ref !== void 0 ? _ref : "ssg";
};
//# sourceMappingURL=config.js.map
